import type { ProductNearToLimit } from 'apiConnector/discover/lifeCycle';
import { Section } from 'components/discover/post-trade/life-cycle/section/section-content';

import type { LifeCycleItemProps } from './section-container';

import 'components/discover/post-trade/life-cycle/index.css';
import { LifeCycleSectionContainer, lifeCycleApi } from './section-container';

export function NearToAutocallSection(props: LifeCycleItemProps) {
  return (
    <LifeCycleSectionContainer title="nearToAutocall" fetchData={lifeCycleApi.fetchNearToAutocall} {...props}>
      {(product: ProductNearToLimit) => (
        <Section.Content
          distanceToLimit={product.distanceToEarlyRedemptionLimit}
          underlyings={product.underlyingList.map(u => ({
            bloombergCode: u.bloombergCode,
            distanceToLimit: u.distanceToEarlyRedemptionLimit,
            limitHit: u.earlyRedemptionLimitHit,
          }))}
        />
      )}
    </LifeCycleSectionContainer>
  );
}
